(() => {
  function init(root = document) {
    root.querySelectorAll('[data-menu]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const nav = document.getElementById(button.getAttribute('aria-controls'));
        if (!nav) return;
        nav.hidden = !nav.hidden;
        button.setAttribute('aria-expanded', String(!nav.hidden));
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.closest('[data-product-studio]') || select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const section = select.closest('.product-page');
        const button = section.querySelector('[data-add-button]');
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Ausverkauft' : 'In den Warenkorb';
        const url = new URL(location.href); url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      });
    });

  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
